import type * as openapi from '@/helpers/api/types/openapiOverrides';

import { AxiosRequestConfig, isCancel } from 'axios';

import * as apiRequestsHelpers from '@/helpers/api/requests';
import {
  // validateAcceptedStatusReqConf,
  // validateCreatedStatusReqConf,
  // validateNoContentStatusReqConf,
  validateOKStatusReqConf,
  // validateOKn404StatusReqConf,
} from '@/helpers/fetchers';
import {
  showErrorNotification,
  // showSuccessNotification,
} from '@/helpers/notifiers';
// import { sendWarning } from '@/helpers/sentry';

export async function fetchGetTicketJobs(
  params: openapi.GetTicketJobs_Query,
  requestConfig: Readonly<AxiosRequestConfig> = {},
): Promise<openapi.GetTicketJobs_200> {
  try {
    const res = await apiRequestsHelpers.getTicketJobs(params, {
      ...validateOKStatusReqConf,
      ...requestConfig,
    });
    return res.data;
  } catch (err) {
    if (!isCancel(err)) {
      showErrorNotification({
        title: 'Error getting all Jobs related to Zammad Ticket',
      });
    }
    throw err;
  }
}

export async function fetchPostTicketNotificationsMarkAllAsRead(
  params: openapi.PostTicketNotificationsMarkAllRead_Query,
  data: openapi.PostTicketNotificationsMarkAllRead_Body,
  requestConfig: Readonly<AxiosRequestConfig> = {},
): Promise<openapi.PostTicketNotificationsMarkAllRead_200> {
  try {
    const res = await apiRequestsHelpers.postTicketNotificationsMarkAllAsRead(
      params,
      data,
      {
        ...validateOKStatusReqConf,
        ...requestConfig,
      },
    );
    return res.data;
  } catch (err) {
    if (!isCancel(err)) {
      showErrorNotification({
        title: 'Error marking as read all related to Ticket notifications',
      });
    }
    throw err;
  }
}

export async function fetchGetTicketDashboardUnread(
  params: openapi.GetTicketDashboardUnread_Query,
  requestConfig: Readonly<AxiosRequestConfig> = {},
): Promise<openapi.GetTicketDashboardUnread_200> {
  try {
    const res = await apiRequestsHelpers.getTicketDashboardUnread(params, {
      ...validateOKStatusReqConf,
      ...requestConfig,
    });
    return res.data;
  } catch (err) {
    if (!isCancel(err)) {
      showErrorNotification({
        title: 'Error getting tickets with unread notifications',
      });
    }
    throw err;
  }
}

export async function fetchGetTicketDashboardAll(
  params: openapi.GetTicketDashboardAll_Query,
  requestConfig: Readonly<AxiosRequestConfig> = {},
): Promise<openapi.GetTicketDashboardAll_200> {
  try {
    const res = await apiRequestsHelpers.getTicketDashboardAll(params, {
      ...validateOKStatusReqConf,
      ...requestConfig,
    });
    return res.data;
  } catch (err) {
    if (!isCancel(err)) {
      showErrorNotification({
        title: 'Error getting all Tickets available to the User',
      });
    }
    throw err;
  }
}

export async function fetchGetTicketDashboardUnreadCount(
  params: openapi.GetTicketDashboardUnreadCount_Query,
  requestConfig: Readonly<AxiosRequestConfig> = {},
): Promise<openapi.GetTicketDashboardUnreadCount_200> {
  try {
    const res = await apiRequestsHelpers.getTicketDashboardUnreadCount(params, {
      ...validateOKStatusReqConf,
      ...requestConfig,
    });
    return res.data;
  } catch (err) {
    if (!isCancel(err)) {
      showErrorNotification({
        title: 'Error getting number of Tickets with unread notifications',
      });
    }
    throw err;
  }
}
